export const LOGIN_TYPE_EMPLOYEE = "employee";
export const LOGIN_TYPE_LIAISON_OFFICER = "family-office-team";
export const LOGIN_TYPE_USER = "user";
export const LOGIN_TYPE_SF = "sflogin";

export const ERROR_CODES = {
  1050: "Username or password incorrect. Please try again",
  1019: "Your OTP is incorrect. Please re-enter the correct OTP.",
};
